module.exports = __webpack_public_path__ + "img/佛山八方艺术街区.db2628be.png";